/**
 * Whether a React event came from a portal. React bubbles a portal's events through
 * its React parents, so the target can sit outside the handling element's DOM.
 */
export const isPortaledEvent = ({
  target,
  currentTarget
}: {
  target: EventTarget | null;
  currentTarget: Element;
}): boolean => !(target instanceof Node && currentTarget.contains(target));
